const getUser = async ({ params, api }) => {
  return await api(`users/${params.id}`)
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default getUser;
